export default __webpack_public_path__ + "static/media/SOSBackground_Blue.c85a88cf.jpg";